import { Container, Box } from '@mui/material';

function Attributions() {
    return (
        <>
            <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
                <h1 className='pp-1'>
                    A Crypto Wallet & Gateway to dApps - Attribution Notice
                </h1>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Permission
                    </h5>
                    <p className='pp-3'>
                        Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to use the Software without limitation. This includes the rights to copy, modify, merge, publish, distribute, and sublicense the Software. The following condition applies: All copies or substantial portions of the Software must include the above copyright notice and this permission notice.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Disclaimer
                    </h5>
                    <p className='pp-3'>
                        THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. IN NO EVENT SHALL THE COPYRIGHT HOLDERS OR CONTRIBUTORS BE LIABLE FOR ANY CLAIM, DAMAGES, OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT, OR OTHERWISE, ARISING FROM, OUT OF, OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                    </p>
                </Box>
            </Container>
        </>
    );
}

export default Attributions;
